import { useNavigation } from "@react-navigation/native";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { kColors } from "src/kColors";
import { kRoute } from "src/kRoute";
import { kStyleConst } from "src/kStyle";

const EmptyCart = (): JSX.Element => {
  const kNav = useNavigation();
  const handleNavToBrands = () => {
    kNav.navigate(kRoute.P99);
  };
  return (
    <View style={styles.container}>
      <Text style={styles.italics}>There are no items in your cart! </Text>
      <TouchableOpacity onPress={handleNavToBrands}>
        <Text style={styles.italicsLink}>Explore our brands</Text>
      </TouchableOpacity>
      <Text style={styles.italics}> to get started</Text>
    </View>
  );
};

export default EmptyCart;

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    flex: 1,
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    marginVertical: kStyleConst.kSpacing * 10,
  },
  italics: {
    fontStyle: "italic",
    lineHeight: kStyleConst.kSpacing * 5,
    opacity: 0.5,
  },
  italicsLink: {
    fontStyle: "italic",
    lineHeight: kStyleConst.kSpacing * 5,
    opacity: 0.5,
    textDecorationColor: kColors.black,
    textDecorationLine: "underline",
  },
});
